<template>
  <b-card no-body>
    <b-card-body>
      <price-package-detail
        ref="pricePackageDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import PricePackageDetail from '@/views/pages/price-packages/PricePackageDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    PricePackageDetail
  },

  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  created() {
    const { id } = this.$route.params;
    this.id = id;
    this.getPricePackage(id);
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editPricePackage(this.id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'price_packages' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getPricePackage(priceId) {
      this.submitting = true;
      useService
        .getPricePackage(priceId)
        .then(response => {
          this.data = response.data;

          const { id, title, description, isDefault, status } = response.data;

          this.data = {
            id,
            title,
            description,
            isDefault,
            status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
